import DOJO_ACTION from '../pages/Dojo/enums/dojoAction'
import BELT_TEST_STATE from '../pages/Dojo/enums/dojoBeltTestStates'
import DOJO_EXERCISE_ANSWER_STATUS from '../pages/Dojo/enums/dojoExerciseAnswerStatus'
import DOJO_MODE from '../pages/Dojo/enums/dojoMode'
import DOJO_OTP_VALID from '../pages/Dojo/enums/dojoOtpValid'

export const initialState = {
    exerciseDetails: {},
    localUserSolutionData: {},
    challengeCounter: 1,
    beltTestDetails: {},
    remTime: 1,
    mode: DOJO_MODE.WORKOUT,
    otpValidity: DOJO_OTP_VALID.NOT_CHANGED,
    beltTestState: BELT_TEST_STATE.INITIAL,
    workoutList: [],
    currentWorkout: {},
    bgm1CurrentTime: 0,
    bgm2CurrentTime: 0,
    isQuestionSolved: false,
}

export const reducer = (state, action) => {
    switch (action.type) {
        case DOJO_ACTION.SET_EXERCISE_DETAILS: {
            return {
                ...state,
                exerciseDetails: action.payload.exercise,
                localUserSolutionData: {
                    ...state.localUserSolutionData,
                    [action.payload.exercise.exercise_info[0].question.id]: {
                        user_solution: {
                            [action.payload.slug]: action.payload.exercise
                                .exercise_info[0].user_solution
                                ? action.payload.exercise.exercise_info[0]
                                      .user_solution[action.payload.slug]
                                : action?.payload?.exercise?.exercise_info[0]
                                      ?.question.default_code[
                                      action?.payload?.slug
                                  ],
                        },
                    },
                    isQuestionSolved:
                        action.payload.exercise.exercise_info[0].status ===
                        DOJO_EXERCISE_ANSWER_STATUS.SOLVED,
                },
            }
        }
        case DOJO_ACTION.SET_LOCAL_USER_SOLUTION_DATA: {
            return {
                ...state,
                localUserSolutionData: {
                    ...state.localUserSolutionData,
                    [action.payload.question_id]: {
                        user_solution: action.payload.user_solution,
                    },
                },
            }
        }
        case DOJO_ACTION.UPDATE_CHALLENGE_COUNTER: {
            return {
                ...state,
                challengeCounter: state.challengeCounter + 1,
            }
        }
        case DOJO_ACTION.SET_BELT_TEST_DETAILS: {
            return {
                ...state,
                beltTestDetails: action.payload.beltTestDetails,
                remTime: Math.floor(action.payload.remTime / 1000),
                otpValidity: action.payload.otpValidity,
                beltTestState: action.payload.beltTestState,
            }
        }

        case DOJO_ACTION.SET_MODE: {
            return {
                ...state,
                mode: action.payload,
                challengeCounter: 1,
            }
        }

        case DOJO_ACTION.SET_OTP_VALIDITY: {
            return {
                ...state,
                otpValidity: action.payload,
            }
        }

        case DOJO_ACTION.SET_BELT_TEST_STATE: {
            return {
                ...state,
                beltTestState: action.payload,
            }
        }

        case DOJO_ACTION.SET_WORKOUT_LIST: {
            return {
                ...state,
                workoutList: action.payload,
            }
        }

        case DOJO_ACTION.SET_CURRENT_WORKOUT: {
            return {
                ...state,
                currentWorkout: action.payload,
            }
        }

        case DOJO_ACTION.DECREMENT_REM_TIME: {
            if (state.remTime <= 0) return state
            return {
                ...state,
                remTime: state.remTime - 1,
            }
        }

        case DOJO_ACTION.SET_BGM_CURRENT_TIME: {
            return {
                ...state,
                bgm1CurrentTime: action.payload.bgm1CurrentTime,
                bgm2CurrentTime: action.payload.bgm2CurrentTime,
            }
        }

        case DOJO_ACTION.SET_QUESTION_SOLVED: {
            return {
                ...state,
                isQuestionSolved: action.payload,
            }
        }

        case DOJO_ACTION.SET_HINTS: {
            return {
                ...state,
                hints: action.payload,
            }
        }
    }
}
